// Module
var code = "<h2 id=\"still-have-questions\">Still have questions?</h2> <p>Contact us today to get the answers you need. </p> ";
// Exports
export default code;